export default __webpack_public_path__ + "static/media/DarigaLovelace.e3f61da0.png";